import { FC, memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Switch } from 'core-components/library/checkbox'

import { useFormField } from '../../hooks'
import { IFormField } from '../../models'

interface IFormSwitch extends IFormField<boolean> {
  className?: string
  label?: string
}

export const FormSwitch: FC<IFormSwitch> = memo(
  ({
    field,
    formKey,
    label,
    defaultValue,
    className,
    onChange,
    isDisabled,
    isRequired,
    isReadOnly,
    isVisible = true,
    margin,
  }) => {
    const { handleChange, value } = useFormField({
      field,
      formKey,
      defaultValue,
      onChange,
      isDisabled,
      isRequired,
      isReadOnly,
      isVisible,
    })

    if (isVisible) {
      return (
        <Switch
          margin={margin}
          inline
          padding
          disabled={isDisabled}
          className={className}
          label={label && <Translation text={label} span actionsInside />}
          checked={value}
          onChange={handleChange}
        />
      )
    }

    return null
  }
)
